module.exports = __webpack_public_path__ + "img/bing.9f4d7c00.svg";